$(function(){
    $('.ls-schach-list').slick({
        slidesToShow: 2.7,
        slidesToScroll: 1,
        infinite: false,
        responsive:[{
            breakpoint:576,
            settings: {
                slidesToShow:1.5
            }
        }]
      });
      $('.ls-product-recommendations-wrapper').css('opacity','0');
})


$(window).on('load', function() {

    $('.ls-product-recommendations-wrapper').css('opacity','1');

    
      
       $('.how-it-works-slideshow .slick-dots').slick({
         draggable:false,
         infinite: false,
		slidesToShow: 6,
         arrows:false,
         
         responsive:[
           
           { 
           breakpoint:1366,
            settings: {
              	draggable:true,
              swipeToSlide: true,
          		infinite: false,
				slidesToShow: 3.4,
        		slidesToScroll: 1,
         }
            },
           { 
           breakpoint:768,
            settings: {
              	draggable:true,
              swipeToSlide: true,
          		infinite: false,
				slidesToShow: 2.4,
        		slidesToScroll: 1,
         }
            },
             {
           
            breakpoint:480,
            settings: {
              	draggable:true,
              swipeToSlide: true,
          		infinite: false,
				slidesToShow: 1.4,
        		slidesToScroll: 1,
             
            }
             },
        ]
         
      })
      setTimeout( function(){ 
        $( `.Wood-option-set` ).hide();
        $( `.Lucite-option-set` ).hide();
        $( `.Fiberglass-option-set` ).hide();
        $( `.${$("input:radio.modularRadio:checked").val()}-option-set` ).show();
      }  , 500 );

    });

/*
    const scroll = new LocomotiveScroll({
        el: document.querySelector('[data-scroll-container]'),
        smooth: true,
        getDirection: true,
    });

    scroll.on('scroll', (instance) => {
        document.documentElement.setAttribute('data-direction', instance.direction)
    });*/
$(document).ready(function(){
  
  
  $("input:radio.modularRadio").change(function(){
        $( `.Wood-option-set` ).hide();
        $( `.Lucite-option-set` ).hide();
        $( `.Fiberglass-option-set` ).hide();
        $( `.${$(this).val()}-option-set` ).show();
    });
  
  $(".variant__button-label").click(function(){
    var index= $(this).attr('data-slick-index');
    $("#ProductPhotos-5649860886696").slick('slickGoTo',index);
  });
           
           $('.custom_recomm .slick-recomm').slick({
             slidesToShow: 3.2,
             arrows: true,
             slidesToScroll: 1,
             infinite: false,
             responsive:[{
               breakpoint: 577,
               settings: {
                 slidesToShow:2.4,
                 slidesToScroll: 1,
               }
             },
             {
           
            breakpoint:481,
            settings: {
				slidesToShow: 1.4,
        		slidesToScroll: 1,
             
            }
             }
         ]
       });
  if ($(window).width() < 769) {
    $('#Slideshow-slideshow .slick-arrow').click(function(){
      var active_slide = $('#Slideshow-slideshow .slick-track .slick-active').attr('data-slick-index');
      $(".slick-dots").slick('slickGoTo',active_slide);
    });
    
  }
});

